import React from "react";

export default function Pagination() {
  return (
    <div>
      <button className="button-pagination">1</button>
      <button className="button-pagination">2</button>
      <button className="button-pagination">3</button>
      {/* <button className="button-pagination">4</button>
      <button className="button-pagination">5</button> */}
      <button className="button-pagination">{">"}</button>
    </div>
  );
}
